import React from "react";
import { useTranslation } from "react-i18next";
import Heading from "../../../Components/Heading/Heading";
import styles from "./NearbySalons.module.css";

import arPhone from "../../../assets/ar_main_phone.png";
import enPhone from "../../../assets/en_main_phone.png";
import hePhone from "../../../assets/he_main_phone.png";

const IMAGES = {
  ar: arPhone,
  he: hePhone,
  en: enPhone,
};

const NearbySalons = () => {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language || "en").split("-")[0];
  const imgSrc = IMAGES[lang] || IMAGES.en;

  return (
    <section className={styles.mainBox}>
      <div className={`container ${styles.parent}`}>
        <section className={styles.child1} data-aos="fade-up" data-aos-duration="500">
          <div className={styles.headingBox}>
            <Heading text={t("putYourBusinessOnMap.heading")} color="#fff" />
          </div>
          <div className={styles.paraBox}>
            <p>{t("putYourBusinessOnMap.paragraph")}</p>
          </div>
        </section>
        <section className={styles.child2} data-aos="fade-up" data-aos-duration="500">
          <img src={imgSrc} alt="Stylon calendar, orders and money views" className={styles.mapMobile} />
        </section>
      </div>
    </section>
  );
};

export default NearbySalons;
